import { useTheme } from '@emotion/react';
import React from 'react';

export const Info = () => {
  const theme = useTheme();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
    >
      <circle
        cx="11"
        cy="11.001"
        r="10"
        stroke={theme.shades.primary5}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.909"
      ></circle>
      <path
        stroke={theme.shades.primary5}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.909"
        d="M13.273 15.55h-1.364a.91.91 0 01-.91-.909v-5.91a.455.455 0 00-.454-.454H9.182M10.767 6a.227.227 0 100 .455.227.227 0 000-.455"
      ></path>
    </svg>
  );
};
